export default function initPrograms() {
    const currentUrl = new URL(document.URL);
    const anchor = currentUrl.searchParams.get("program");

    if (anchor) {
        const element = document.querySelector('.program-' + anchor);

        if (element) {
            element.click();

            window.scroll({
                top: element.getBoundingClientRect().top + window.scrollY - 200,
                behavior: 'smooth',
            });
        }
    }
}
